<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Kanonkop Paul Sauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        C'è qualche discussione sull'età del Sudafrica come regione vinicola. Mentre abbiamo
                        testimonianze di viti risalenti al 17° secolo, le terre vinicole non sono realmente entrate nel loro
                        proprio fino all'inizio del XX secolo. E di questi vecchi vigneti commerciali, Kanonkop Paul Sauer
                        è forse la luce principale.
                    </div>

                    <div class="howto-title2">Il principe del Pinotage</div>
                    <div class="howto-text">
                        Quattro generazioni di Sauer gestiscono la tenuta di famiglia da oltre quattro decenni. Oggi gestito dal team dei fratelli Johann e Paul Krige (pronipoti di Paul Sauer), questa visione costante ha fatto sì che Kanonkop sia oggi un punto di riferimento per i vini pregiati sudafricani, in particolare lo speciale SA, Pinotage. Incentrato sulla produzione di vini pregiati di alta qualità con un carattere chiaro da uve endemiche, il Pinotage di Kanonkop è considerato tra i migliori al mondo. Kanonkop ha fatto molta strada per cambiare l'opinione del mercato sul Pinotage, spesso considerato “privo di eleganza, goffo e dal sapore di vernice”.
                        <br><br>
                        Gran parte del successo di Kanonkop ha a che fare con l'enologo Abrie Beeslaar, che è stato con il
                        famiglia Sauer/Krige dal 1973. L'arrivo di Beeslaar a Kanokop ha coinciso con la decisione di
                        iniziare a imbottigliare il proprio vino. Un uomo meticoloso che controlla i vini dei 140 ettari
                        tenuta “dalla potatura delle viti alla spedizione” al fine di garantire la massima qualità possibile,
                        indipendentemente dal prestigio del vino. “Ricevono tutti lo stesso trattamento, indipendentemente dal fatto che lo siano
                        vini di volume o un'annata etichetta nera”.
                    </div>

                    <div class="howto-title2">Un vino vincente</div>
                    <div class="howto-text">
                        Kanonkop ha davanti a sé un brillante futuro. Descritto da “quelli che sanno” come il Sud
                        Equivalente africano di un Premier Cru o First Growth, la tenuta è stata la prima azienda sudafricana a farlo
                        riceve 100 punti per la sua annata 2015. Ottenuto da un blend di 70% Cabernet Sauvignon, 15% Merlot
                        e 15% Cabernet Franc, il 2015 è “un perfetto swing da golf”, e sta aprendo la strada al Sud
                        I vini pregiati africani vengono alla luce.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Kanonkop Paul Sauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Es gibt einige Meinungsverschiedenheiten über das Alter Südafrikas als Weinregion. Während wir haben
                        Es gibt Hinweise auf Reben, die bis ins 17. Jahrhundert zurückreichen. Die Weinanbaugebiete kamen jedoch nicht wirklich zur Geltung
                        im Besitz bis Anfang des 20. Jahrhunderts. Und von diesen älteren kommerziellen Weinbergen Kanonkop Paul Sauer
                        ist vielleicht das führende Licht.
                    </div>

                    <div class="howto-title2">Der Prinz des Pinotage</div>
                    <div class="howto-text">
                        Vier Generationen von Sauern führen das Familiengut seit über vier Jahrzehnten. Diese stetige Vision, die heute vom Team der Brüder Johann und Paul Krige (Paul Sauers Urenkel) geführt wird, hat dazu geführt, dass Kanonkop heute ein Maßstab für erlesene südafrikanische Weine ist, insbesondere für den südafrikanischen Spezialwein Pinotage. Kanonkops Pinotage konzentriert sich auf die Herstellung hochwertiger, erlesener Weine mit klarem Charakter aus endemischen Trauben und gilt als einer der besten der Welt. Kanonkop hat viel dazu beigetragen, die Meinung des Marktes über Pinotage zu ändern, der oft als „mangelhaft, ungeschickt und nach Lack schmeckend“ angesehen wird.
                        <br><br>
                        Ein großer Teil des Erfolgs von Kanonkop hat mit dem Winzer Abrie Beeslaar zu tun, der bei Kanonkop tätig war
                        Familie Sauer/Krige seit 1973. Beeslaars Ankunft in Kanokop fiel mit der Entscheidung zusammen
                        Beginnen Sie mit der Abfüllung Ihres eigenen Weins. Ein akribischer Mann, der die Weine der 140 Hektar kontrolliert
                        Weingut „vom Rebschnitt bis zum Versand“, um die höchstmögliche Qualität zu gewährleisten,
                        unabhängig vom Prestige des Weines. „Sie werden alle gleich behandelt, egal, ob sie es sind oder nicht
                        Volumenweine oder ein Black-Label-Jahrgang“.
                    </div>

                    <div class="howto-title2">Ein Trumpfwein</div>
                    <div class="howto-text">
                        Kanonkop hat eine glänzende Zukunft vor sich. Von „Kennern“ als der Süden beschrieben
                        Das afrikanische Äquivalent eines Premier Cru oder First Growth war das erste südafrikanische Weingut
                        erhält 100 Punkte für seinen Jahrgang 2015. Hergestellt aus einer Mischung aus 70 % Cabernet Sauvignon und 15 % Merlot
                        und 15 % Cabernet Franc ist der 2015er „ein perfekter Golfschwung“ und ebnet den Weg in den Süden
                        Afrikanische Spitzenweine kommen ans Licht.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Canonkop Paul Sauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il y a un argument concernant l'âge de l'Afrique du Sud en tant que région viticole. Alors que nous avons
                        témoignage de vignes datant du 17ème siècle, les vignobles n'ont pas vraiment pris leur essor
                        propre jusqu'au début du XXe siècle. Et parmi ces vignobles commerciaux plus anciens, Kanonkop Paul Sauer
                        est peut-être le chef de file.
                    </div>

                    <div class="howto-title2">Le prince de Pinotage</div>
                    <div class="howto-text">
                        Quatre générations de Sauers dirigent le domaine familial depuis plus de quatre décennies. Aujourd'hui dirigée par l'équipe des frères Johann et Paul Krige (arrière-petits-fils de Paul Sauer), cette vision constante a fait de Kanonkop une référence pour les vins fins sud-africains, notamment la spéciale SA, Pinotage. Axé sur la fabrication de vins fins de haute qualité avec un caractère clair à partir de raisins endémiques, le Pinotage de Kanonkop est considéré comme l'un des meilleurs au monde. Kanonkop a fait beaucoup pour changer l'opinion du marché sur le Pinotage, souvent considéré comme "manquant d'élégance, maladroit et au goût de vernis".
                        <br><br>
                        Une grande partie du succès de Kanonkop est due au vigneron Abrie Beeslaar, qui a été avec le
                        Famille Sauer/Krige depuis 1973. L'arrivée de Beeslaar à Kanokop a coïncidé avec la décision de
                        commencer à embouteiller son propre vin. Un homme méticuleux qui contrôle les vins des 140 hectares
                        domaine « de la taille des vignes à l'expédition » afin d'assurer la meilleure qualité possible,
                        quel que soit le prestige du vin. "Ils reçoivent tous le même traitement, qu'ils soient
                        des vins en volume ou une cuvée étiquette noire ».
                    </div>

                    <div class="howto-title2">Un vin d'atout</div>
                    <div class="howto-text">
                        Kanonkop a un bel avenir devant lui. Décrit par « ceux qui savent » comme étant le Sud
                        Équivalent africain d'un Premier Cru ou Premier Grand Cru, le domaine a été le premier sud-africain à
                        reçoit 100 points pour son millésime 2015. Issu d'un assemblage de 70% Cabernet Sauvignon, 15% Merlot
                        et 15 % de cabernet franc, le 2015 est « un swing de golf parfait », et ouvre la voie au Sud
                        Des vins fins africains à venir dans la lumière.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Kanonkop Paul Sauer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        There is some argument regarding the age of South Africa as a wine region. While we have
                        evidence of vines dating back to the 17th century, the winelands did not really come into their
                        own until the early 20th century. And of these older commercial vineyards, Kanonkop Paul Sauer
                        is perhaps the leading light.
                    </div>

                    <div class="howto-title2">The prince of Pinotage</div>
                    <div class="howto-text">
                        Four generations of Sauers have been running the family estate for over four decades. Today run by the team of brothers Johann and Paul Krige (Paul Sauers great-grandsons), this steady vision has meant that Kanonkop is today a benchmark for South African fine wines, notably the SA special, Pinotage. Focused on making high-quality fine wines with clear character from endemic grapes, Kanonkop’s Pinotage is considered to be among the best in the world. Kanonkop has gone a long way to change the market opinion of Pinotage, often considered as “lacking in elegance, clumsy and tasting like varnish”.
                        <br><br>
                        Much of Kanonkop’s success has to do with winemaker Abrie Beeslaar, who has been with the
                        Sauer/Krige family since 1973. Beeslaar’s arrival at Kanokop coincided with the decision to
                        begin bottling their own wine. A meticulous man who controls the wines from the 140-hectares
                        estate “from pruning vines to the shipping” in order to ensure the highest possible quality,
                        regardless of the prestige of the wine. “They all get the same treatment, whether they are
                        volume wines or a black label vintage”.
                    </div>

                    <div class="howto-title2">A trump wine</div>
                    <div class="howto-text">
                        Kanonkop has a bright future ahead of it. Described by “those in the know” as being the South
                        African equivalent of a Premier Cru or First Growth, the estate was the first South African to
                        receive 100-points for its 2015 vintage. Made of a blend of 70% Cabernet Sauvignon, 15% Merlot
                        and 15% Cabernet Franc, the 2015 is “a perfect golf-swing”, and is paving the way for South
                        African fine wines to come into the light.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KanonkopPaulSauer",
    data() {
        return {
            select: {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Kanonkop Paul Sauer | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich flavors and high-quality winemaking traditions of Kanonkop Paul Sauer, a premium wine producer based in the heart of the Stellenbosch wine region in South Africa. With a focus on producing premium Cabernet Sauvignon and Pinotage wines, each bottle of Kanonkop Paul Sauer is a testament to the winery\'s passion for excellence.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
